import {
    Box,
    Typography,
    Button,
    Menu,
    MenuItem,
    TextField,
    Stack,
    useMediaQuery,
    useTheme,
    Chip,
} from "@mui/material";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {
    CalendarToday,
    Today,
    EventNote,
    DateRange,
    ExpandMore,
    AccessTime,
} from "@mui/icons-material";
import { format } from "date-fns";
import { useLocation } from "react-router-dom";
import PageURL from "../../constants/PageURL";
import { useSelector } from "react-redux";

const SubHeader2 = ({
    open,
    selectedValue = {},
    selectedLebel = {},
    sestSelectedLebel = () => { },
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const { projectDetail } = useSelector((state) => state.projectDetail);

    const [anchorEl, setAnchorEl] = useState(null);
    const [activeDateSelection, setActiveDateSelection] = useState(null);
    const location = useLocation();

    const intervalValue = projectDetail?.plantDataAvailability?.timeInterval;

    useEffect(() => {
        if (selectedLebel.startDate && selectedLebel.endDate) {
            const start = new Date(selectedLebel.startDate);
            start.setHours(0, 0, 0, 0); // Start of day (00:00:00)

            let end = new Date(selectedLebel.endDate);

            // Handle month-wise range
            if (selectedLebel.dateRangeType === "month") {
                end = new Date(end.getFullYear(), end.getMonth() + 1, 0); // Last day of month
            }
            // Handle year-wise range
            else if (selectedLebel.dateRangeType === "year") {
                end = new Date(end.getFullYear() + 1, 0, 0); // Last day of year
            }

            end.setHours(23, 59, 59, 999); // End of day (23:59:59.999)

            const startTimestamp = Math.floor(start.getTime() / 1000);
            const endTimestamp = Math.floor(end.getTime() / 1000);

            sestSelectedLebel({
                ...selectedLebel,
                startTimestamp,
                endTimestamp,
                isReady: true, // Mark as ready
            });
        }
    }, [selectedLebel.endDate, selectedLebel.dateRangeType]); // Add dateRangeType to dependencies

    useEffect(() => {
        const isSpecialPage = [
            PageURL.INDIA_INVERTER_DEVIATION,
            PageURL.INDIA_INVERTER_EFFICIENCY,
            PageURL.SCBSMB_LOSS,
            PageURL.INDIA_INVERTER_HEATMAP_DIAGRAM,
        ].includes(location.pathname);
        sestSelectedLebel({
            ...selectedLebel,
            startDate: isSpecialPage && intervalValue ? new Date() : null,
            endDate: isSpecialPage && intervalValue ? new Date() : null,
            dateRangeType: intervalValue && isSpecialPage ? intervalValue : "month",
            startTimestamp: null,
            endTimestamp: null,
            isReady: true,
        });
    }, [location.pathname]);

    const handleRangeTypeChange = (type) => {
        if (selectedLebel?.dateRangeType === type) {
            setAnchorEl(null);
            setActiveDateSelection(null);

            return;
        }

        sestSelectedLebel({
            ...selectedLebel,
            dateRangeType: type,
            // startDate: type === intervalValue ? new Date() : null,
            // endDate: type === intervalValue ? new Date() : null,
            startTimestamp: null,
            endTimestamp: null,
        });
        setAnchorEl(null);
        setActiveDateSelection(null);
    };

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px 25px",
                backgroundColor: "#f5f7fa",
                borderBottom: "1px solid #e0e0e0",
                position: "sticky",
                top: 0,
                zIndex: 1100,
                flexDirection: "row",
                gap: isMobile ? 2 : 0,
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: !open && !isMobile ? "2rem" : 0,
                    flexWrap: "wrap",
                    rowGap: 1,
                }}
            >
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                    {selectedValue.country || "Country"}
                </Typography>
                <ArrowForwardIosIcon sx={{ fontSize: 14, mx: 1 }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                    {selectedValue.partnerName || "Partner Name"}
                </Typography>
                <ArrowForwardIosIcon sx={{ fontSize: 14, mx: 1 }} />
                <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                    {selectedValue.projectName || "Project Name"}
                </Typography>
            </Box>

            {/* Right side - Date range selector */}


            <Stack
                direction="row"
                alignItems="center"
                gap={1}
                sx={{ flexWrap: "wrap" }}
            >
                <Button
                    variant="outlined"
                    onClick={(e) => setAnchorEl(e.currentTarget)}
                    startIcon={
                        selectedLebel?.dateRangeType === "5_min" ? (
                            <AccessTime />
                        ) : selectedLebel?.dateRangeType === "day" ? (
                            <Today />
                        ) : selectedLebel?.dateRangeType === "month" ? (
                            <EventNote />
                        ) : selectedLebel?.dateRangeType === "year" ? (
                            <DateRange />
                        ) : (
                            <CalendarToday />
                        )
                    }
                    endIcon={<ExpandMore />}
                    sx={{
                        textTransform: "capitalize",
                        minWidth: 100,
                    }}
                >
                    {selectedLebel?.dateRangeType}
                </Button>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                >
                    {/* {
                        (location.pathname.includes("predictive/inverter/heatmap-diagram") || location.pathname.includes("predictive/inverter-availability") || location.pathname.includes("predictive/scbsmbstring-loss")) &&

                        <MenuItem onClick={() => handleRangeTypeChange("5_min")}>
                            <Today sx={{ mr: 1 }} /> 5-min
                        </MenuItem>
                    } */}

                    <MenuItem onClick={() => handleRangeTypeChange("day")}>
                        <Today sx={{ mr: 1 }} /> Day
                    </MenuItem>

                    <MenuItem onClick={() => handleRangeTypeChange("month")}>
                        <EventNote sx={{ mr: 1 }} /> Month
                    </MenuItem>
                    <MenuItem onClick={() => handleRangeTypeChange("year")}>
                        <DateRange sx={{ mr: 1 }} /> Year
                    </MenuItem>

                </Menu>

            </Stack>

        </Box>
    );
};

export default SubHeader2;
